'use strict';

// Babel6 does not hack the default behaviour of ES Modules anymore, so we should export

var Collapse = require('./Collapse').default;

module.exports = Collapse;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-collapse/lib/index.js
// module id = 507
// module chunks = 0